import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import SVGInline from 'react-svg-inline';

// SVGs
import aperture from 'assets/icon-aperture.svg';
import map from 'assets/icon-map.svg';
import tables from 'assets/icon-tables.svg';
import trends from 'assets/icon-trends.svg';

// Styles
import styles from './tile.scss';

const svgs = {
  aperture,
  map,
  tables,
  trends,
};

/**
 * A link with an SVG logo and a label.
 * @param  {string} options.label       Text label for link.
 * @param  {string} options.destination Path where link should take you.
 * @param  {string} options.icon        File name of icon to display.
 * @return {object}                     JSX component.
 */
const Tile = ({
  label,
  destination,
  icon,
}) => (
  <NavLink
    to={destination}
    className={styles.tile}
    activeClassName={styles.activeTile}
  >
    <SVGInline
      svg={svgs[icon] || ''}
      className={styles.icon}
      cleanup
    />
    <span className={styles.label}>
      {label}
    </span>
  </NavLink>
);

Tile.defaultProps = {
  icon: '',
};

Tile.propTypes = {
  label: PropTypes.string.isRequired,
  destination: PropTypes.string.isRequired,
  icon: PropTypes.string,
};

export default Tile;



// WEBPACK FOOTER //
// ./app/components/tile/index.js